import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import { useTranslate } from '../../contexts/languageContext';
import { useIsMobile } from '../../hooks/useMediaQuery';
import FilaTablaEstadisticasListas from './FilaTablaEstasdisticasListas';
import TabsFilterListas from './TabsFilterListas';
import { cantidadDeListasPorSector } from '../../resources/constantes.json';
/**
 * Tabla que muestra los resultados obtenidos por candidatura y con un desglose
 * por curules para cada candidato de esa candidatura
 */
const TablaEstadisticasListas = ({ nomenclator, data }) => {
  const isMobile = useIsMobile();
  const t = useTranslate();
  const [filtroPorSector, secFiltroPorSector] = useState(
    data.camaras[0].codcam
  );
  const [listas, setListas] = useState(
    data.partotabla.slice(0, cantidadDeListasPorSector)
  );
  const filterListas = param => {
    secFiltroPorSector(param);
    setListas(
      data.partotabla
        .filter(x => x.act.cam === param)
        .slice(0, cantidadDeListasPorSector)
    );
  };
  useEffect(() => {
    filterListas(filtroPorSector);
  }, [data]);
  return (
    <>
      <>
        <TabsFilterListas
          filtroPorSector={filtroPorSector}
          secFiltroPorSector={filterListas}
          data={data}
          nomenclator={nomenclator}
        />
        <FakeHeaderRow aria-hidden="true">
          <FakeHeaderCell css="width: 70%; background-color: white;">
            <span css="vertical-align: super; margin-left: 93px; line-height: 40px; background-color: white;">
              {t('listas')}
            </span>
          </FakeHeaderCell>
          <FakeHeaderCell css="width: 30% ; background-color: white;   text-align: center;">
            <span css="vertical-align: super; line-height: 40px; background-color: white;">
              {t('votos')}
            </span>
          </FakeHeaderCell>
        </FakeHeaderRow>
        <Table>
          {!!listas && listas.length > 0 ? (
            listas.map((item, index) => (
              <FilaTablaEstadisticasListas
                item={item}
                index={index}
                ambito={data.amb}
                isMobile={isMobile}
                nomenclator={nomenclator}
              />
            ))
          ) : (
            <h2>{t('noHayInformacion')}</h2>
          )}
        </Table>
      </>
    </>
  );
};

export default TablaEstadisticasListas;

const FakeHeaderRow = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  top: 0;
  background: white;
`;

const FakeHeaderCell = styled.div`
  vertical-align: middle;
  margin: 0 auto;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;

  color: #222222;
`;

const Table = styled.ul`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  border-collapse: collapse;
`;
